module.exports = __webpack_public_path__ + "static/media/img_client_fitt@3x.30b282dc.png";